import { apiClient } from '../utils/apiClient.js';

/** @typedef {import('../models/types').FileUploadHistoryDto} FileUploadHistoryDto */

/**
 * Get file upload history for an organization.
 * @param {number} organizationId
 * @param {boolean} [recent]
 * @returns {Promise<FileUploadHistoryDto[]>}
 */
export async function getFileUploadHistory(organizationId, recent = false) {
  const queryParam = recent ? `?recent=${recent}` : '';
  const response = await apiClient.get(`/api/FileUploadHistory/organizations/${organizationId}${queryParam}`);
  return response;
}
